
import { BookkeepingService } from "@/services/bookkeeping-service";
import { VatDeclarationPeriod } from "@/utils/vat-delcaration/period";
import AppAccountingVatDeclarationPeriodMonth from "./AccountingVatDeclarationPeriodMonth.vue";
import AppAccountingVatDeclarationPeriodQuarter from "./AccountingVatDeclarationPeriodQuarter.vue";
import AppAccountingVatDeclarationPreview from "./AccountingVatDeclarationPreview.vue";

import Vue from "vue";
import { VatDeclarationData } from "@/utils/vat-delcaration/data";
import { VatDeclarationResultData } from "@/utils/vat-delcaration/result-data";
import { printHumanFloat } from "@/utils/pretty-print";
import { BookYearService } from "@/services";

export default Vue.extend({
	data(){
		return {
			isRunning: false,
			period: null as VatDeclarationPeriod | null,
			data: new VatDeclarationData(),
			selectedPeriodTab: 0,
			result: null as VatDeclarationResultData | null,
			year: BookYearService.selectedBookYear
		};
	},
	computed: {
		periodTabs():string[]{
			return ["for-month", "for-quarter"].map((s)=>{
				return this.$ct(s).toString();
			});
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async notifyOfPreviousData(){
			if (!this.result) return;
			let previousData = this.result.AddedFromPreviousDeclarations.getNot0Values();
			if (previousData.length == 0) {
				return;
			}
			let text = "";
			for (let item of previousData){
				text+= this.$ct("vat-declaration-value-found-in-previous-declaration", {amount: printHumanFloat(item.value), grid: item.grid});
			}
			await this.$wf.dialog(text, this.$ct("common.ok"), this.$ct("common.info"));
		},
		async notifyForExtraValuesForNextDeclaration(){
			if (!this.result) return;
			let toAddValues = this.result.getValuesToAddForNextDeclarations();
			if (toAddValues.length ==0) return;
			let text = this.$ct("vat-declaration-to-add-values-found").toString();
			for (let item of toAddValues){
				text += this.$ct("vat-declaration-grid-with-value", {grid: item.grid, amount: printHumanFloat(item.value)}).toString();
			}
			await this.$wf.dialog(text, this.$ct("common.ok"), this.$ct("common.info"));
		},
		async notifyForNegativeValuesForNextDeclaration(){
			if (!this.result) return;
			let negativeValues = this.result.getNegativeValuesToAddToNextDeclaration();
			console.log(negativeValues);
			if (negativeValues.length == 0) return;
			let text = this.$ct("vat-declaration-negative-values-found").toString();
			for (let item of negativeValues){
				text += this.$ct("vat-declaration-grid-with-value", {grid: item.grid, amount: printHumanFloat(item.value)}).toString();
			}
			text += this.$ct("vat-declaration-added-to-next-declaration").toString();
			await this.$wf.dialog(text, this.$ct("common.ok"), this.$ct("common.info"));
		},
		async confirm(){
			if (!this.period) return;
			if (this.isRunning) return;
			this.data.Period = this.period;
			this.data.Period.Year = this.year;
			this.isRunning = true;
			try{
				this.result = await BookkeepingService.createVatDeclarationData(this.data);
				await this.notifyOfPreviousData();
				await this.notifyForNegativeValuesForNextDeclaration();
				await this.notifyForExtraValuesForNextDeclaration();
			}catch(err){

			}
			this.isRunning = false;
		}
	},
	components: {
		AppAccountingVatDeclarationPeriodMonth,
		AppAccountingVatDeclarationPeriodQuarter,
		AppAccountingVatDeclarationPreview
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
